module.exports = __webpack_public_path__ + "static/CV_Oct2020Columbia_Polleux_F-f02253de326fc781d7a0ff212a8e175b.pdf";